import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { CdnVendor, MutationResult } from "@modules/graphql/types"
import { useCreateNetlifySiteMutation } from "@modules/cdn/netlify/queries.generated"
import { useSetCdnConfigMutation } from "@modules/cdn/shared/queries.generated"
import { netlifyIntegrationConfig as text } from "@modules/locales/default.js"

export const useCreateNetlifyIntegration = (
  onComplete: (
    mutationResult: Pick<MutationResult, "success" | "errorType">
  ) => void
) => {
  const [setError, errorAlert] = useTriggerErrorAlert()
  const [
    createIntegration,
    { loading: loadingIntegration },
  ] = useSetCdnConfigMutation()

  const [
    createNetlifyIntegrationMutation,
    { loading, error },
  ] = useCreateNetlifySiteMutation()

  const createNetlifyIntegration = async (
    siteId: string,
    siteName: string,
    account: string
  ) => {
    try {
      const { data } = await createNetlifyIntegrationMutation({
        variables: {
          serviceName: siteName,
          siteId,
          accountName: account,
        },
      })

      if (
        !data?.createNetlifySite?.validation?.success ||
        !data?.createNetlifySite?.netlifySite?.id
      ) {
        throw new Error(
          data?.createNetlifySite?.validation?.message ??
            text.messages.siteCreationFailed
        )
      }

      const { data: integrationData } = await createIntegration({
        variables: {
          siteId,
          serviceId: data?.createNetlifySite?.netlifySite?.id,
          serviceName: siteName,
          accountName: account,
          vendor: CdnVendor.Netlify,
        },
      })

      return onComplete({
        success: integrationData?.setCDNConfig?.success ?? false,
        errorType: integrationData?.setCDNConfig?.errorType,
      })
    } catch (err) {
      setError(err)
    }
  }

  return [
    createNetlifyIntegration,
    { error, errorAlert, loading: loading || loadingIntegration },
  ] as const
}
